import React from 'react'
import styled from 'styled-components'

// Styled Components
const BoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const Box = styled.div`
  width: 350px;
  height: 350px;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  background-size: cover;
  background-position: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin: 25px;

  &:nth-child(2),
  &:nth-child(3) {
    @media (max-width: 768px) {
      display: none;
      width: 100px;
      height: 100px;
    }
  }
  @media (max-width: 768px) {
    display: none;
    width: 100px;
    height: 100px;
  }
`

const Image = ({ img1, img2, img3, wid, height }) => {
  return (
    <BoxWrapper>
      <Box imageUrl={img1} wid={wid} height={height} />
      {img2 && <Box imageUrl={img2} wid={wid} height={height} />}
      {img3 && <Box imageUrl={img3} wid={wid} height={height} />}
    </BoxWrapper>
  )
}

export default Image
